<script>
import store from '../store';
import axios from "axios";
import Vue from 'vue';

export default new Vue({
    computed:{
        basket(){
            return store.getters.GetBasket || [];
        },
        checkoutInfo(){
            return store.getters.GetCheckoutInfo;
        },
        anyClickAndCollectItems(){
            for(var i=0;i<this.basket.length;i++)
            {
                if(this.basket[i].OnlyInShops)
                    return true;
            }
            return false;
        }
    },
    methods:{
        async checkInventory(){
            return new Promise((resolve, reject)=>{
                    axios.post(window["baseUrl"] + "umbraco/Surface/bshopbasket/checkInventory", this.basket).then((res)=>{
                        resolve(res.data);
                    }, reject);
                });
        },
        async checkout(ageToken){
            if(this.checkoutInfo.paymentType == "mobile")
                return new Promise((resolve, reject)=>{
                    axios.post(window["baseUrl"] + "umbraco/Surface/bshopbasket/checkoutMobile", {
                        basket : this.basket,
                        checkoutInfo : this.checkoutInfo,
                        ageToken : ageToken,
                    }).then((res)=>{
                        // resolve(res);
                        // debugger;
                        // console.log("res", res);
                        document.location.href = res.data;
                    }, reject);
                });
            else if(this.checkoutInfo.paymentType == "ean")
                return new Promise((resolve, reject)=>{
                    axios.post(window["baseUrl"] + "umbraco/Surface/bshopbasket/checkoutEan", {
                        basket : this.basket,
                        checkoutInfo : this.checkoutInfo,
                        ageToken : ageToken
                    }).then((res)=>{
                        resolve(res);
                    }, reject);
                });
            else if(this.checkoutInfo.paymentType == "bank")
                return new Promise((resolve, reject)=>{
                    axios.post(window["baseUrl"] + "umbraco/Surface/bshopbasket/checkoutBank", {
                        basket : this.basket,
                        checkoutInfo : this.checkoutInfo,
                        ageToken : ageToken
                    }).then((res)=>{
                        resolve(res);
                    }, reject);
                });
            else
                return new Promise((resolve, reject)=>{
                    axios.post(window["baseUrl"] + "umbraco/Surface/bshopbasket/checkoutCredit", {
                        basket : this.basket,
                        checkoutInfo : this.checkoutInfo,
                        ageToken : ageToken
                    }).then((res)=>{
                        // resolve(res);
                        document.location.href = res.data;
                    }, reject);
                });
        },
        updateCheckoutInfo(checkoutInfo){
            store.dispatch('UpdateCheckoutInfo', checkoutInfo);
        },
        removeItem(itemNo, color){
            var items = store.getters.GetBasket;
            var existingItem = this.getLine(itemNo, color);
            items.splice(items.indexOf(existingItem),1);
            store.dispatch('UpdateBasket', items);
            app.$gtm.trackEvent({
                'event': 'removeFromCart',
                'no' : itemNo
            });
        },
        clear(){
            store.dispatch('UpdateBasket', []);
            app.$gtm.trackEvent({
                'event': 'clearCart'
            });
        },
        updateQuantity(no, quantity, color)
        {
            var items = store.getters.GetBasket;
            var existingItem = this.getLine(no, color);
            existingItem.Quantity = quantity;
            store.dispatch('UpdateBasket', items);
            app.$gtm.trackEvent({
                'event': 'updateCart',
                'no' : no,
                'quantity':quantity
            });
        },
        addItem(item, quantity, color){
            if(color == "Hvid")
                color = null;
            
            var items = store.getters.GetBasket;
            var existingItem = this.getLine(item.No, color);
            if(existingItem)
                existingItem.Quantity += quantity;
            else
                items.push({...item, Quantity:quantity, Color: color});
            existingItem = this.getLine(item.No, color);
            store.dispatch('UpdateBasket', items);

            app.$gtm.trackEvent({
                'event': 'addToCart',
                'item' : item,
                'quantityAdded':quantity,
                'quantityTotal':existingItem.Quantity,
                'unitPriceForQuantity':this.getLinePrice(existingItem),
                'totalLinePrice':this.getLinePrice(existingItem)*existingItem.Quantity
            });
        },
        getLine(itemNo, color)
        {
            if(color == "Hvid")
                color = null;
            var items = store.getters.GetBasket;
            var item = items.filter(i=>i.No == itemNo && (!color || color == i.Color));
            return item.length>0 ? item[0] : null;
        },
        isTwelveDiscount(){
            var count = 0;
            store.getters.GetBasket.map(basketLine=>{
                if(basketLine.SalePrices.find(sp=>sp.MinQuantity==12))
                {
                    count += basketLine.Quantity;
                }
            });
            return count>=12;
        },
        getLinePrice(basketLine){
            var isTwelveDiscount = this.isTwelveDiscount();
            var bestPrice = basketLine.UnitPrice;
            basketLine.SalePrices
                .filter(sp=>sp.MinQuantity<=basketLine.Quantity || (sp.MinQuantity == 12 && this.isTwelveDiscount()))
                .map(sp=>{
                    if(sp.UnitPrice < bestPrice)
                        bestPrice = sp.UnitPrice;
                });
            return bestPrice * basketLine.Quantity;
        },
        getSubtotal(discountMultiplier){
            if(!discountMultiplier)
                discountMultiplier = 1;
            var rtn = 0;
            this.basket.map(basketLine => rtn += this.getLinePrice(basketLine)*discountMultiplier);
            // extra items
            this.basket
                .filter(line => line.ExtraLines && line.ExtraLines.length>0)
                .map(line => line.ExtraLines.map(ex=>rtn += ex.QuantityPer * line.Quantity * ex.UnitPrice))
            return rtn;
        },
        getTotalLeadTimeDays(){
            var maxLead = 0;
            this.basket.map(line=>{
                if(line.LeadTimeDays>maxLead)
                    maxLead = line.LeadTimeDays;
            });
            return maxLead;
        },
        getShippingCost(discountMultiplier, specialFragt){
            switch(specialFragt)
            {
                case "free":return 0;
                case "island":return 625;
                default:return this.getSubtotal(discountMultiplier)<1000 ? 59.95 : 0;
            }            
        }
    },    
});
</script>